module.exports = __webpack_public_path__ + "static/bar-gold-5d044bb6bbcbb0f2977fa9089a31655c.png";